const product_card = [{
        id: 1,
        product_name: "Bright Idea Moisturizer",
        description: "Vitamin C + Tri-Peptide Collagen Protecting &amp; Brightening Moisturizer",
        price: 26,
        currency: "$",
        thumb: "https://cdn11.bigcommerce.com/s-9p889rxpkb/product_images/uploaded_images/bright-idea-section-moisturizer-resized.png"
    },
    {
        id: 2,
        product_name: "Bright Idea Serum",
        description: "Vitamin C + Tri-Peptide Collagen Protecting &amp; Brightening Serum",
        price: 28,
        currency: "$",
        thumb: "https://cdn11.bigcommerce.com/s-9p889rxpkb/product_images/uploaded_images/bright-idea-section-resized.png"
    },
    {
        id: 3,
        product_name: "Bright Idea Eye Cream",
        description: "Vitamin C + Tri-Peptide Collagen Protecting Eye Cream",
        price: 25,
        currency: "$",
        thumb: "https://cdn11.bigcommerce.com/s-9p889rxpkb/product_images/uploaded_images/bright-idea-section-eye-cream-resized.png"
    },
    {
        id: 4,
        product_name: "Bright Idea Face Mask",
        description: "Holographic Foil Sheet Mask",
        price: 4,
        currency: "$",
        thumb: "https://cdn11.bigcommerce.com/s-9p889rxpkb/product_images/uploaded_images/331499757-bi-sheet-mask-front-290x290-min.jpg"
    },
    {
        id: 5,
        product_name: "Let’s C Results Skincare Kit",
        description: "A $79 Value",
        price: 63,
        currency: "$",
        thumb: "https://cdn11.bigcommerce.com/s-9p889rxpkb/product_images/uploaded_images/required.png"
    },
    {
        id: 6,
        product_name: "Bright Idea Moisturizer Travel Mini",
        description: "Vitamin C + Tri-Peptide Collagen Protecting & Brightening Moisturizer",
        price: 6,
        currency: "$",
        thumb: "https://cdn11.bigcommerce.com/s-9p889rxpkb/product_images/uploaded_images/bright-idea-section-moisturizer-resized.png"
    },
    // {
    //     id: 7,
    //     product_name: "Rayes Alpha",
    //     description: "Hands-free, Hads-on Mushc Experience",
    //     price: 350,
    //     currency: "$",
    //     thumb: "./images/1.png"
    // },
    // {
    //     id: 8,
    //     product_name: "Rayes Z30",
    //     description: "Hands-free, Hads-on Mushc Experience",
    //     price: 250,
    //     currency: "$",
    //     thumb: "./images/2.png"
    // },
    // {
    //     id: 9,
    //     product_name: "Rayes X30",
    //     description: "Hands-free, Hads-on Mushc Experience",
    //     price: 350,
    //     currency: "$",
    //     thumb: "./images/3.png"
    // }
]
export default product_card;